import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propFunc, propNumber, propShape, } from '../../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../../helpers/recompose';
import FullScreenModalHoc from '../../../../../../../Ui/Modal/FullScreenModal/FullScreenModalHoc';
import RfpOneDescriptionTabContentText from './RfpOneDescriptionTabContentText';
import RfpOneDescriptionTabHead from './RfpOneDescriptionTabHead';
const RfpOneDescriptionTabContentModal = (props) => {
    const { changeTabIndex, items, tabIndex, viewRequest } = props;
    return (_jsx("div", Object.assign({ className: 'rfp-description-tab-full_screen_wrap' }, { children: _jsxs("div", Object.assign({ className: 'rfp-description-tab' }, { children: [_jsx(RfpOneDescriptionTabHead, { changeTabIndex: changeTabIndex, items: items, tabIndex: tabIndex }), _jsx("div", Object.assign({ className: 'content_row' }, { children: _jsx("div", Object.assign({ className: 'content_inner_row' }, { children: _jsx(RfpOneDescriptionTabContentText, { lines: 0, tabIndex: tabIndex, viewRequest: viewRequest }) })) }))] })) })));
};
RfpOneDescriptionTabContentModal.propTypes = {
    changeTabIndex: propFunc().isRequired,
    items: propArrayShape().isRequired,
    tabIndex: propNumber().isRequired,
    viewRequest: propShape().isRequired,
};
const enhance = compose(FullScreenModalHoc);
export default enhance(RfpOneDescriptionTabContentModal);
